import { keyBy } from 'lodash'
import {
  FETCH_VENUE_SETTINGS_REQUESTED,
  FETCH_VENUE_SETTINGS_SUCCEEDED,
  FETCH_VENUE_SETTINGS_FAILED,
  CREATE_VENUE_SETTINGS_REQUESTED,
  CREATE_VENUE_SETTINGS_SUCCEEDED,
  CREATE_VENUE_SETTINGS_FAILED,
} from './constants'

const initialState = {
  byName: {},
  isLoading: false,
}

const state = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_VENUE_SETTINGS_REQUESTED: {
      return {
        ...state,
        isLoading: true,
      }
    }

    case FETCH_VENUE_SETTINGS_SUCCEEDED: {
      const settings = payload.filter(
        (setting) =>
          setting.standId === null && setting.deactivatedAt === null
      )

      return {
        ...state,
        isLoading: false,
        byName: keyBy(settings, 'name'),
      }
    }

    case FETCH_VENUE_SETTINGS_FAILED: {
      return {
        ...state,
        isLoading: false,
      }
    }

    case CREATE_VENUE_SETTINGS_REQUESTED: {
      return {
        ...state,
        isLoading: true,
      }
    }

    case CREATE_VENUE_SETTINGS_SUCCEEDED: {
      return {
        ...state,
        isLoading: false,
        byName: {
          ...state.byName,
          ...keyBy(payload, 'name'),
        },
      }
    }

    case CREATE_VENUE_SETTINGS_FAILED: {
      return {
        ...state,
        isLoading: false,
      }
    }

    default:
      return state
  }
}

export default state
